module.exports = __webpack_public_path__ + "static/img/1.959803a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TechnicalSupport/equipment/Assembly/1.png
// module id = ukub
// module chunks = 13